import { CCXOverallTabTableDataItem } from './CCXDetailsTab';

/**
 * Determines if a contact has variance in CCX star ratings across different dimensions
 * @param data - The contact data containing CCX ratings for different dimensions
 * @returns true if there is variance in the star ratings, false otherwise
 */
export const hasStarRatingVariance = (
  data: CCXOverallTabTableDataItem
): boolean => {
  // Get all non-null star ratings
  const ratings = [
    data.ccxOverall,
    data.ccxEmpathy,
    data.ccxCourtesy,
    data.ccxKnowledgeable,
    data.ccxUnderstand,
    data.ccxHelpfulness,
    data.ccxEfficiency,
  ].filter(rating => rating !== null && rating !== undefined);

  // If there are less than 2 ratings, we can't have variance
  if (ratings.length < 2) return false;

  // Check if all ratings are the same
  const firstRating = ratings[0];
  return !ratings.every(rating => rating === firstRating);
};
